import isMobileBrowser from 'is-mobile'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGlobe, faLink } from '@fortawesome/pro-light-svg-icons'
import { faStar } from '@fortawesome/pro-solid-svg-icons'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import {
  Box, DashboardModuleListItem, Image, Text,
} from '@domain-group/suit-theme'

import type { CampaignModel } from '@models/types'

import placeholderImageUrl from './assets/campaign_image_400x400-1.png'

interface CampaignListItemProps {
  campaign: CampaignModel,
  selectedPriorityUserId?: number,
}

const CampaignListItem = (props: CampaignListItemProps) => {
  const { campaign, selectedPriorityUserId } = props
  const {
    address,
    agency_marketing,
    default_image,
    hidden,
    id,
    priority_campaign_user_ids: priorityUserIds,
    published,
    suburb_name,
    title,
  } = campaign

  const portal = campaign.data?.portal

  const isMobile = isMobileBrowser()

  const buildCampaignTitle = (agency_marketing ? title : address) + (hidden ? ' (Archived)' : '')

  const isPriorityCampaignForCurrentUser = selectedPriorityUserId && priorityUserIds?.includes(selectedPriorityUserId)

  return (
    <DashboardModuleListItem
      childrenHolderProps={{ overflow: 'visible' }}
      href={`#/campaigns/${id}/edit?redirect=${generateRedirectUrl()}`}
      imageComponent={(
        <Image
          borderRadius={5}
          boxProps={{ border: '1px solid', borderColor: 'lineColor' }}
          placeholderUrl={placeholderImageUrl}
          url={default_image}
        >
          {isPriorityCampaignForCurrentUser && (
            <Box
              height="100%"
              position="relative"
            >
              <Box position="absolute" left={0} top={0}>
                <Text color="blue" fontSize="xsmall" padding="2px">
                  <FontAwesomeIcon icon={faStar} />
                </Text>
              </Box>
            </Box>
          )}
        </Image>
      )}
      secondaryText={suburb_name}
      title={buildCampaignTitle}
    >
      {!isMobile && (
        <Box justifyContent="center" flexDirection="column" marginLeft="auto">
          {published && (
            <Text color="bodyFontLightColor" fontSize="xsmall" textAlign="right">
              <FontAwesomeIcon icon={faGlobe} /> Published
            </Text>
          )}

          {portal && (
            <Text color="bodyFontLightColor" fontSize="xsmall" marginTop={published ? 'medium' : 0} textAlign="right">
              <FontAwesomeIcon icon={faLink} /> Syncing from {portal.title}
            </Text>
          )}
        </Box>
      )}
    </DashboardModuleListItem>
  )
}

export default CampaignListItem
